import { useSelector } from 'react-redux'
import Select from 'react-select'
import userRole from '../../../../../config/userRole'
import { selectRole } from '../../../../../slices/authSlice'
import { selectGroups } from '../../../../../slices/groupSlice'
import RadioButton, {
  RadioItem,
} from '../../../../UtilComponent/level_1/RadioButton'
import IsFavorite from './IsFavorite'

const FilterCategory = (props: any) => {
  const { filter, setFilter, setSelectedGroup, isFavorites, setIsFavorites } = props

  const contactGroups = useSelector(selectGroups)

  const role = useSelector(selectRole)

  const radioItems: RadioItem[] = [
    { id: 'all', value: 'all', label: '全て' },
    { id: 'shared', value: 'shared', label: '共有' },
    { id: 'personal', value: 'personal', label: '個人' },
  ]
  const radioName = 'filter'

  
  const personalContactGroups = contactGroups.filter((group) => group.groupCategory === "personal")
  const sharedContactGroups = contactGroups.filter((group => group.groupCategory === "shared"))

  const options = [
    ...personalContactGroups.map((group) => {
      return {
        value: group.id,
        label: group.groupName,
        group: '個人'
      }
    }),
    ...sharedContactGroups.map((group) => {
      return {
        value: group.id,
        label: group.groupName,
        group: '共有'
      }
    })
  ]

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'blue' : (state.data.group === '個人' ? 'green' : 'orange'),
      color: 'white',
    }),
    group: (provided: any) => ({
      ...provided,
      backgroundColor: 'gray',
    }),
    groupHeading: (provided: any) => ({
      ...provided,
      color: 'white',
    }),
  };

  

  return (
    <div className='switcher'>
      {role === userRole["一般ユーザー"] &&
        <>
          <RadioButton
            state={filter}
            setState={setFilter}
            name={radioName}
            items={radioItems}
          />
        
          <IsFavorite isFavorites={isFavorites} setIsFavorites={setIsFavorites} />
        </>
      }
      <Select options={options} styles={customStyles} isMulti placeholder="グループを選択してください" 
      onChange={(e)=> {
        setSelectedGroup(e.map((option) => option.value))
      }} />
      <span></span>
    </div>
  )
}

export default FilterCategory
